import { baseURL } from '@functions/api'

import { PropertySuggestionModel } from '@models/types'

import callApi from './callApi'

type SuggestPropertyParams = {
  string: string,
}

export const suggestProperty = async (params: SuggestPropertyParams) => {
  const { string } = params

  const options = {
    string: JSON.stringify(string),
  }

  const endpoint = `${baseURL}/data_providers/suggest`
  const result = await callApi<PropertySuggestionModel[]>(endpoint, options)

  return result
}

export default suggestProperty
